// extracted by mini-css-extract-plugin
export default {"miklase":"toast_miklase__gwBZg"};